import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTwitchComponent } from './simple-icons-twitch.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTwitchComponent ],
    exports:      [ SimpleIconsTwitchComponent ],
    bootstrap:    []
})
export class SimpleIconsTwitchModule {}
